import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import { FormBox, InputBox } from "../../../../components/AntdAddons";
import { SearchOutlined } from "@ant-design/icons";
import { CONSTANT } from "../../../../config/Constant";
import dayjs from "dayjs";
import { disabledSaveBtn } from "../../../../config/Global";

const FilterForm = (props) => {
  const { getList, setPaginationData } = props;
  const [form] = Form.useForm();
  const [disabledClear, setDisabledClear] = useState(true);
  const [disabledSearch, setDisabledSearch] = useState(true);

  const handleSubmit = (data: any) => {
    const payload = {
      ...data,
      createdAt: data?.createdAt
        ? dayjs(data?.createdAt).format(CONSTANT.POST_DATE_HOURS_FORMAT)
        : null,
    };
    setPaginationData({
      page_number: 1,
      page_size: 10,
    });
    getList(payload);
    setDisabledClear(false);
  };
  const clear = () => {
    form.resetFields();
    const payload = {
      page_number: 1,
      page_size: 10,
    };
    setPaginationData({
      page_number: 1,
      page_size: 10,
    });
    getList(payload);
    setDisabledSearch(true);
    setDisabledClear(true);
  };
  const disableFutureDates = (current: any) => {
    return (
      current > dayjs().endOf("day") ||
      current.isBefore(dayjs().subtract(30, "day"))
    );
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        const isDisabled = disabledSaveBtn(form);
        setDisabledSearch(isDisabled);
      })
      .catch((e: any) => {
        setDisabledSearch(true);
        console.warn(e);
      });
  };
  return (
    <>
      <FormBox
        className="filterForm"
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={["onBlur", "onInput"]}
        autoComplete="off"
      >
        <Row gutter={30} align={"middle"}>
          <Col xs={24} md={12} lg={8} xl={6}>
            <InputBox.Text name="request_id" label="Requested ID" />
          </Col>
          <Col xs={24} md={12} lg={8} xl={6}>
            <InputBox.Text name="random_number" label="Number" />
          </Col>
          <Col xs={24} md={12} lg={8} xl={6}>
            <InputBox.Select
              name="reported_app"
              label="Reported App"
              allowClear
              placeholder="Reported App"
              options={{
                list: CONSTANT.REPORTEDAPP,
                valueKey: "value",
                textKey: "id",
              }}
              onChange={handleChange}
            />
          </Col>
          <Col xs={24} md={12} lg={8} xl={6}>
            <InputBox.Select
              name="response"
              label="Response"
              allowClear
              placeholder="Response"
              options={{
                list: CONSTANT.WEBHOOKRESPONSE,
                valueKey: "value",
                textKey: "id",
              }}
              onChange={handleChange}
            />
          </Col>
          <Col xs={24} md={12} lg={8} xl={6}>
            <InputBox.DatePicker
              label="Select date"
              placeholder="Select date"
              allowClear
              name={"createdAt"}
              showTime={{ format: "HH" }}
              format={CONSTANT.POST_DATE_HOURS_FORMAT}
              disabledDate={disableFutureDates}
              onChange={handleChange}
            />
          </Col>
        </Row>
        <Row gutter={30} align={"middle"}>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button type="primary" htmlType="submit" disabled={disabledSearch}>
              <SearchOutlined /> Search
            </Button>
          </Col>
          <Col xs={12} md={12} lg={6} xl={3}>
            <Button
              type="default"
              htmlType="reset"
              disabled={disabledClear}
              onClick={() => {
                clear();
              }}
            >
              Clear
            </Button>
          </Col>
        </Row>
      </FormBox>
    </>
  );
};

export default FilterForm;
